









































































import Vue from 'vue';
import GiftStatus from '@/web/components/gift/GiftStatus.vue';
import sales from '@/core/api/modules/sales';
import { ValidationObserver } from 'vee-validate';
import { pick } from 'lodash';

export default Vue.extend({
  name: 'EditGiftPurchaseModal',
  components: {
    GiftStatus,
    ValidationObserver,
  },
  props: {
    giftPurchase: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      inProgress: false,
      formData: {
        date: {
          startDate: null,
          endDate: null,
        },
      },
    };
  },
  methods: {
    async save() {
      this.inProgress = true;
      try {
        const data = {
          send_at: this.formData.date.startDate,
          ...pick(this.formData, [
            'recipient_first_name',
            'recipient_last_name',
            'recipient_email',
            'message',
          ]),
        };
        await sales.updateGiftPurchase(this.giftPurchase.id, data);
        this.$parent.$emit('finish');
        this.$emit('close');
      } catch (error) {
        this.inProgress = false;
        this.$notify({
          group: 'app',
          type: 'error',
          text: this.$t('GENERAL.ERROR.GIFT_PURCHASES_UPDATE_FAILED'),
          duration: -1, // stay ON
        });
        return;
      }
    },
  },
  mounted() {
    this.formData = {
      date: {
        startDate: this.giftPurchase.send_at,
        endDate: this.giftPurchase.send_at,
      },
      ...pick(this.giftPurchase, [
        'recipient_first_name',
        'recipient_last_name',
        'recipient_email',
        'message',
      ]),
    };
  },
});
